
import '../../../../assets/css/screens/customer/dashboard/notifications/Notifications.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import { ArrowLeft, Bell } from 'lucide-react';
import NotificationSkeleton from "../../../../components/skeltonloading/NotificationSkeleton";
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';

const NotificationCard = ({ notification, markAsRead }) => {

  const handleClick = () => {

   if (notification.status === "unread"){
      markAsRead(notification.id);
    }

  };


  return (

    <div
      onClick={handleClick}
    className={`notif-card ${
  notification.status === 'unread'
    ? 'unread'
    : ''
}`}
    >

      <div className="notif-icon-wrap icon-blue">
        <Bell
          size={22}
          className="notif-icon"
        />
      </div>


      <div className="notif-content">

        <h6 className="notif-title">
          {notification.title}
        </h6>

        <p className="notif-message">
          {notification.description}
        </p>

        <p className="notif-time">
          {new Date(notification.created_at).toLocaleDateString()}
        </p>

      </div>


     {notification.status === 'unread' &&  (
        <span className="notif-dot"></span>
      )}

    </div>

  );
};

const Notifications = () => {

  const { baseUrl } = useContext(AppContext);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  // get notifications
  useEffect(() => {
setLoading(true);
    axios.get(`${baseUrl}/customer/notifications`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      }
    })
      .then((response) => {

        console.log(response.data);

        setNotifications(response.data.notifications);

      })
      .catch((error) => {

        console.log(error);

      })
 .finally(() => {

      setLoading(false);

    });
  }, []);
  // mark as read
  const markAsRead = (id) => {

    axios.post(
      `${baseUrl}/customer/notification/read/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    )
      .then((response) => {

        console.log(response.data);


        // frontend pe bhi status change
        setNotifications(prev =>
          prev.map(item =>
            item.id === id
              ? { ...item, status: "read" }
              : item
          )
        );


      })
      .catch(error => {

        console.log(error);

      });

  };

  if (loading) {
  return (
    <>
      <AppNavbar />
      <NotificationSkeleton />
    </>
  );
}


  // clear 
  const clearAllNotifications = () => {

  axios.post(
    `${baseUrl}/customer/notifications/clear`,
    {},
    {
      headers:{
        Authorization:`Bearer ${localStorage.getItem("authToken")}`
      }
    }
  )
  .then((response)=>{

    console.log(response.data);

    // frontend se remove
    setNotifications([]);

  })
  .catch((error)=>{
    console.log(error);
  });

};

  return (
    <>
      <AppNavbar />

      <div className="notif-page">
        <div className="notif-wrapper">

      <div className="notif-header">

  <button
    className="notif-back-btn"
    onClick={() => window.history.back()}
  >
    <ArrowLeft size={20} />
  </button>

  <h2 className="notif-heading">
    Notifications
  </h2>


  <button
    className="notif-clear-btn"
    onClick={clearAllNotifications}
  >
    Clear All
  </button>

</div>

          <div className="notif-list">

            {notifications.length > 0 ? (

              notifications.map((notif) => (

                <NotificationCard
                  key={notif.id}
                  notification={notif}
                  markAsRead={markAsRead}
                />

              ))

            ) : (
  <div className="notif-empty-box">

    <div className="notif-empty-icon">
      <Bell size={45}/>
    </div>

    <h3>No Notifications</h3>

    <p>
      You don't have any notifications yet.
    </p>

  </div>
)}

          </div>

        </div>
      </div>
    </>
  );
};

export default Notifications;